import { BookOpen, Target, ShieldAlert } from "lucide-react";

export const NIVEIS = [
  { value: 5, label: "Excelente", short: "EXC", resumo: "Plenamente adequado", cls: "bg-emerald-600 hover:bg-emerald-500", ring: "ring-emerald-400", badge: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40" },
  { value: 4, label: "Bom", short: "BOM", resumo: "Acima do esperado", cls: "bg-blue-600 hover:bg-blue-500", ring: "ring-blue-400", badge: "bg-blue-500/20 text-blue-300 border-blue-500/40" },
  { value: 3, label: "Regular", short: "REG", resumo: "Adequado / aceitável", cls: "bg-amber-600 hover:bg-amber-500", ring: "ring-amber-400", badge: "bg-amber-500/20 text-amber-300 border-amber-500/40" },
  { value: 2, label: "Ruim", short: "RUI", resumo: "Abaixo do esperado", cls: "bg-orange-600 hover:bg-orange-500", ring: "ring-orange-400", badge: "bg-orange-500/20 text-orange-300 border-orange-500/40" },
  { value: 1, label: "Insuficiente", short: "INS", resumo: "Desempenho insuficiente", cls: "bg-red-600 hover:bg-red-500", ring: "ring-red-400", badge: "bg-red-500/20 text-red-300 border-red-500/40" },
];

export const NIVEL_BY_VALUE = Object.fromEntries(NIVEIS.map((n) => [n.value, n]));

export const DEFS_PADRAO = {
  "5": "Executa com elevado domínio, segurança e autonomia.",
  "4": "Executa corretamente, com pequenas falhas.",
  "3": "Executa parcialmente; requer correção/orientação.",
  "2": "Dificuldades significativas comprometem a execução.",
  "1": "Não demonstra a competência mínima esperada.",
};

export const DIMENSOES = {
  conhecimento: { label: "Conhecimento", color: "#38BDF8", icon: BookOpen, badge: "bg-sky-500/15 text-sky-300 border-sky-500/40" },
  habilidade: { label: "Habilidade", color: "#A855F7", icon: Target, badge: "bg-purple-500/15 text-purple-300 border-purple-500/40" },
  atitude: { label: "Atitude", color: "#F59E0B", icon: ShieldAlert, badge: "bg-amber-500/15 text-amber-300 border-amber-500/40" },
};

export const ESCALA_PRATICA = { 1: "Insuficiente", 2: "Regular", 3: "Bom", 4: "Muito Bom", 5: "Ótimo" };

// Cores do conceito para a escala prática (Primeiro Interventor / Negociação)
export function conceitoColor(label) {
  const map = {
    "Ótimo": "bg-emerald-500/20 text-emerald-300 border-emerald-500/40",
    "Muito Bom": "bg-blue-500/20 text-blue-300 border-blue-500/40",
    "Bom": "bg-amber-500/20 text-amber-300 border-amber-500/40",
    "Regular": "bg-orange-500/20 text-orange-300 border-orange-500/40",
    "Insuficiente": "bg-red-500/20 text-red-300 border-red-500/40",
  };
  return map[label] || nivelLabelColor(label);
}

export function nivelLabelFor(value, escala) {
  if (escala && (escala[value] || escala[String(value)])) return escala[value] || escala[String(value)];
  return NIVEL_BY_VALUE[value]?.label || String(value);
}

export function nivelLabelColor(label) {
  const n = NIVEIS.find((x) => x.label === label);
  return n ? n.badge : "bg-slate-500/20 text-slate-300 border-slate-500/40";
}

// ---------- Avaliação Formativa (escala 0-10, incrementos de 0,5) ----------
export const FORMATIVA_VALORES = Array.from({ length: 21 }, (_, i) => i * 0.5); // 0 .. 10

export function fmtNota(v) {
  if (v === null || v === undefined) return "—";
  return Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 1 });
}

// classe de fundo (botões) por valor 0-10
export function formativaBtn(v) {
  if (v < 4) return "bg-red-600 hover:bg-red-500 ring-red-400";
  if (v < 6) return "bg-amber-600 hover:bg-amber-500 ring-amber-400";
  if (v < 8) return "bg-teal-600 hover:bg-teal-500 ring-teal-400";
  return "bg-emerald-600 hover:bg-emerald-500 ring-emerald-400";
}

// badge (média/nota) por valor 0-10
export function formativaBadge(v) {
  if (v === null || v === undefined) return "bg-slate-500/20 text-slate-300 border-slate-500/40";
  if (v < 4) return "bg-red-500/20 text-red-300 border-red-500/40";
  if (v < 6) return "bg-amber-500/20 text-amber-300 border-amber-500/40";
  if (v < 8) return "bg-teal-500/20 text-teal-300 border-teal-500/40";
  return "bg-emerald-500/20 text-emerald-300 border-emerald-500/40";
}
